import React, { Component } from 'react'
import { Button, Card, Icon, Select, Alert } from "antd"
import TableTemplate from "./TableTemplate"
import BulkCreatedEmbroideryBatchesModal from "./BulkCreatedEmbroideryBatchesModal"
import {
    batchesNotPushStatics,
    getListPartnerWithSku,
    createEmbroideryBatchesBySkus,
} from "../../../../services/api/3dApi"


class SkuNotBatches extends Component {
    state = {
        loading: false,
        error: '',
        data: [],
        total_all: '-',
        ListPartnerWithSku: {},
        is_cheap_product: '',
        selectedEmbroiderySkus: [],
        bulkLoading: false,
        bulkError: '',
        bulkResultBatches: {},
        isShowBulkResultModal: false,
    }

    componentDidMount() {
        this._fetchStaticsCreated()
        this._getListSku()
    }

    _getListSku = async () => {
        this.setState({
            loading: true,
            error: '',
        })
        try {
            const { data: res } = await getListPartnerWithSku()
            const { success, data, message } = res
            if (!success) {
                return this.setState({
                    loading: null,
                    error: message,
                })
            }

            this.setState({
                loading: false,
                ListPartnerWithSku: data,
            })
        } catch (e) {
            this.setState({
                loading: null,
                error: e.message,
            })
        }

    }

    _sliceArray = (data) => {
        const length = data.length
        const floor = Math.floor(length / 3)
        const surplus = length % 3
        let newArray = []
        let newArray2 = []
        let newArray3 = []

        if (surplus === 1) {
            newArray = data.slice(0, floor + 1)
            newArray2 = data.slice(floor + 1, floor * 2 + 1)
            newArray3 = data.slice(floor * 2 + 1, length)
        } else if (surplus === 2) {
            newArray = data.slice(0, floor + 1)
            newArray2 = data.slice(floor + 1, floor * 2 + 2)
            newArray3 = data.slice(floor * 2 + 2, length)
        } else {
            newArray = data.slice(0, floor)
            newArray2 = data.slice(floor, floor * 2)
            newArray3 = data.slice(floor * 2, length)
        }

        return [newArray, newArray2, newArray3]
    }

    _sliceStatics = (data) => {
        const { ListPartnerWithSku } = this.state
        let partnerBinhMinh = []
        let partnerToanCau = []
        let partnerQuangMinh = []
        let partnerOther = []

        if (data.length > 0 && !!Object.keys(ListPartnerWithSku).length) {
            data.map(item => {
                if (!!ListPartnerWithSku['BINH MINH'] && ListPartnerWithSku['BINH MINH'].includes(item.type)) {
                    return partnerBinhMinh.push(item)
                } else if (!!ListPartnerWithSku['TOÀN CẦU'] && ListPartnerWithSku['TOÀN CẦU'].includes(item.type)) {
                    return partnerToanCau.push(item)
                } else if (!!ListPartnerWithSku['QUANG MINH'] && ListPartnerWithSku['QUANG MINH'].includes(item.type)) {
                    return partnerQuangMinh.push(item)
                } else {
                    return partnerOther.push(item)
                }
            })
        }

        return [partnerBinhMinh, partnerToanCau, partnerQuangMinh, partnerOther]
    }

    _fetchStaticsCreated = async () => {
        const { is_cheap_product } = this.state
        this.setState({
            loading: true,
            error: ''
        })

        try {
            const payload = {}
            if (!!is_cheap_product && is_cheap_product !== 'all') payload.is_cheap_product = is_cheap_product
            const { data: response } = await batchesNotPushStatics(payload)

            const { success, data, message } = response

            if (!success) {
                return this.setState({
                    loading: null,
                    error: message
                })
            }

            this.setState({
                loading: false,
                data: data.statistic,
                total_all: data.total_all
            })
        } catch (e) {
            this.setState({
                loading: null,
                error: e.message
            })
        }
    }

    handleCheapProduct = (value) => {
        this.setState({ is_cheap_product: value }, () => {
            this._fetchStaticsCreated()
        })
    }

    _toggleEmbroiderySku = (skuType, isChecked) => {
        this.setState(prev => {
            const selected = prev.selectedEmbroiderySkus
            if (isChecked) {
                if (selected.includes(skuType)) return null
                return { selectedEmbroiderySkus: [...selected, skuType] }
            }
            return { selectedEmbroiderySkus: selected.filter(s => s !== skuType) }
        })
    }

    _toggleAllEmbroiderySkus = (isChecked) => {
        const { data, ListPartnerWithSku } = this.state
        const binhMinhSkus = (ListPartnerWithSku['BINH MINH'] || [])
        const embroiderySkus = data
            .filter(i => binhMinhSkus.includes(i.type))
            .filter(i => i.production_process && i.production_process.name === 'Thêu')
            .map(i => i.type)

        this.setState(prev => {
            if (!isChecked) {
                return { selectedEmbroiderySkus: prev.selectedEmbroiderySkus.filter(s => !embroiderySkus.includes(s)) }
            }
            const merged = Array.from(new Set([...prev.selectedEmbroiderySkus, ...embroiderySkus]))
            return { selectedEmbroiderySkus: merged }
        })
    }

    _handleBulkCreateEmbroideryBatches = async () => {
        const { selectedEmbroiderySkus } = this.state
        if (!selectedEmbroiderySkus.length) return
        if (this.state.bulkLoading) return

        this.setState({ bulkLoading: true, bulkError: '' })

        try {
            const { data: response } = await createEmbroideryBatchesBySkus({
                skus: selectedEmbroiderySkus,
            })
            const { success, data, message: mess } = response || {}
            if (!success) throw new Error(mess || 'Tạo lô thất bại')
            this.setState({
                bulkResultBatches: data || {},
                isShowBulkResultModal: true,
                selectedEmbroiderySkus: [],
                bulkLoading: false,
            })
            this._fetchStaticsCreated()
        } catch (e) {
            this.setState({ bulkError: e.message || 'Có lỗi xảy ra', bulkLoading: false })
        }
    }

    _closeBulkResultModal = () => {
        this.setState({
            isShowBulkResultModal: false,
            bulkResultBatches: {},
        })
    }

    render() {
        const {
            data, loading, error, total_all, is_cheap_product,
            selectedEmbroiderySkus, bulkLoading, bulkError,
            bulkResultBatches, isShowBulkResultModal,
        } = this.state
        const newData = this._sliceStatics(data)
        const partnerQM1 = newData[2].slice(0, Math.round(newData[2].length / 2))
        const partnerQM2 = newData[2].slice(Math.round(newData[2].length / 2), newData[2].length)
        const Option = Select.Option
        const cheapProductsOption = [
            {
                name: 'All',
                value: 'all',
            },
            {
                name: 'Giá rẻ',
                value: 'true',
            },
            {
                name: 'Thường',
                value: 'false',
            },
        ]

        return (
            <div className='SkuNotBatches p-3'>
                <Card
                    className="m-3 ProductionProgress"
                    title="Thống kê số lượng SKU chưa phân lô"
                    extra={<Icon type="pie-chart" />}
                >
                    <div className="d-flex justify-content-between mb-3">
                        <div className="Total mb-3">
                            Tổng số: <span>{total_all}</span> {total_all > 1 ? 'items' : 'item'}
                        </div>
                        <div className="filter">
                            <Select
                                showArrow={true}
                                className='mr-0 ml-auto text-left'
                                allowClear
                                style={{ minWidth: '190px', maxWidth: '450px' }}
                                placeholder='Sản phẩm giá rẻ'
                                onChange={(value) => this.handleCheapProduct(value)}
                                defaultValue={is_cheap_product || []}
                            >
                                {
                                    cheapProductsOption.map((item, index) =>
                                        <Option key={index} value={item.value}>
                                            {item.name}
                                        </Option>
                                    )
                                }
                            </Select>
                        </div>
                    </div>

                    <div
                        className={`TableStatics d-flex justify-content-between ${newData[3].length > 0 ? 'Column4' : 'Column3'}`}>
                        <TableTemplate
                            label={'Quang Minh'}
                            data={!!newData ? partnerQM1 : []}
                            loading={loading}
                            error={error}
                        />
                        <TableTemplate
                            data={!!newData ? partnerQM2 : []}
                            loading={loading}
                            error={error}
                        />
                        <TableTemplate
                            label={'Bình Minh'}
                            data={!!newData ? newData[0] : []}
                            loading={loading}
                            error={error}
                            bulkLoading={bulkLoading}
                            enableEmbroideryBulk={true}
                            selectedEmbroiderySkus={selectedEmbroiderySkus}
                            onToggleEmbroiderySku={this._toggleEmbroiderySku}
                            onToggleAllEmbroiderySkus={this._toggleAllEmbroiderySkus}
                            onBulkCreateEmbroideryBatches={this._handleBulkCreateEmbroideryBatches}
                        />
                        <TableTemplate
                            label={'Toàn Cầu'}
                            data={!!newData ? newData[1] : []}
                            loading={loading}
                            error={error}
                        />

                        {
                            !!newData && newData[3].length > 0 && <TableTemplate
                                label={'Other'}
                                data={!!newData ? newData[3] : []}
                                loading={loading}
                                error={error}
                            />
                        }
                    </div>

                    {!!bulkError && (
                        <Alert
                            className='mt-2'
                            type='error'
                            message={bulkError}
                            closable
                            onClose={() => this.setState({ bulkError: '' })}
                        />
                    )}
                </Card>

                <BulkCreatedEmbroideryBatchesModal
                    visible={isShowBulkResultModal}
                    onClose={this._closeBulkResultModal}
                    data={bulkResultBatches}
                />
            </div>
        )
    }
}

export default SkuNotBatches
